import buttonClasses from './buttonClasses'

function Button({
  variant = 'primary',
  size = 'md',
  className,
  onClick,
  disabled = false,
  children,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses({ variant, size, className })}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
